import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import 'common-ui/lib/styles/index.scss';
import 'common-ui/lib/assets/css/style.css';
import { TicketingUserProvider } from './context/TicketingUserContext';
import TicketingRoot from './TicketingRoot';
import { store, persistor } from './store';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <TicketingUserProvider>
          <TicketingRoot />
        </TicketingUserProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
